export default __webpack_public_path__ + "static/color_water-3cd2622d12185eed603d3669b25c5604.mp4";